import React from 'react';
import MainNavBar from '@/common/Navbar/MainNavBar';
import { AlertProvider } from '@/components/Alert';


function MainLayout(page: React.ReactElement) {

  return (
    <AlertProvider>
    <div className="h-screen bg-linear-primary bg-cover bg-fixed md:flex overflow-y-auto scrollbar-apple md:pl-8">
      <MainNavBar />

      <main className="flex-grow w-full p-5 md:p-8">
        {page}
      </main>
    </div>
    </AlertProvider>
  );
}

export default MainLayout;
